export default __webpack_public_path__ + "static/media/smart_storage.d79a2683.mp4";